import React, {Component} from 'react'
import Slider from 'react-slick'
import {Base64} from 'js-base64'
// import {connect} from "react-redux";
import RelatedProduct from "../components/product-common/related-product"
import Breadcrumb from "../components/breadcrumb";
import DetailsWithPrice from "../components/product-common/details-price";
import DetailsTopTabs from "../components/product-common/details-top-tabs";
// import {addToCart, addToCartUnsafe, addToWishlist} from '../../actions'
import ImageZoom from '../components/product-common/image-zoom'
import SmallImages from '../components/product-common/small-image'
import { graphql } from 'gatsby'
import SEO from '../components/seo';
import ProductSchema from '../components/schema-dts/product';
import Layout from '../layouts';

import '../../static/assets/scss/widget.scss'

class Product extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
            vertical:true,
            fetchingReviews: true,
            reviewsData: null
        };
    }

    getReviews = () => {
        if(typeof fetch === 'function') {
            const productId = this.props.data.shopifyProduct.id
            if(productId !== null) {
            const pIdB64 = productId.replace('Shopify__Product__','')
            const pId = Base64.decode(pIdB64).match(/(\d*)$/gm)[0]
            
            fetch('https://staticw2.yotpo.com/batch', {
                method: 'POST',
                headers:{
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    "methods": [{
                        "method":"main_widget",
                        "params": {
                          "pid": pId
                         }
                    },
                  {
                    "method":"bottomline",
                        "params": {
                          "pid": pId,
                          "skip_average_score": false
                         }
                    }
                  ],
                  "app_key":"TmJl1EKB1v3qhdcx6WEO44JihQNKLoeyQFQ7X2Rk"
                  })
            })
            .then(response => response.json())
            .then(data => {
                this.setState({reviewsData: data, fetchingReviews: false})
            })
            .catch(err => this.setState({fetchingReviews: false}))
        } else {
            this.setState({fetchingReviews: false})
        }
        }
    }

    componentWillMount() {
        if(typeof window !== 'undefined') {
            if (window.innerWidth > 576) {
                this.setState({vertical:true})
            }else{
                this.setState({vertical:false})
            }
        }
        this.getReviews()
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
    }

    render(){
        const product = this.props.data.shopifyProduct
        const relatedProducts = this.props.data.allShopifyProduct.edges

        // const {symbol, item, addToCart, addToCartUnsafe, addToWishlist} = this.props
        var products = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true
        };
        var productsnav = {
            vertical: this.state.vertical,
            verticalSwiping: this.state.vertical,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.product-right-slick',
            arrows: false,
            infinite: true,
            centerMode: true,
            dots: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        centerMode: true,
                        dots: true
                    }
                }
            ]
        };

        return (
            <Layout>
                <SEO title={product.title} />
                <Breadcrumb  title={' Product / '+product.title} />
                <ProductSchema product={product}/>
                {/*Section Start*/}
                <section>
                    <div className="collection-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-1 col-sm-2 col-xs-12 p-0">
                                    <SmallImages images={product.smallImages} settings={productsnav} navOne={this.state.nav1} />
                                </div>
                                <div className="col-lg-5 col-sm-10 col-xs-12  order-up">
                                    <Slider {...products} asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)} className="product-right-slick">
                                        {product.images.map((image, index) =>
                                            <div key={index}>
                                                <ImageZoom image={image} className="img-fluid image_zoom_cls-0" />
                                            </div>
                                        )}
                                    </Slider>
                                </div>
                                <DetailsWithPrice fetchingReviews={this.state.fetchingReviews} reviewsData={this.state.reviewsData} product={product} navOne={this.state.nav1} />
                                {/* addToCartClicked={addToCart} BuynowClicked={addToCartUnsafe} addToWishlistClicked={addToWishlist} */}
                            </div>
                        </div>
                    </div>
                </section>
                {/*Section End*/}

                <section className="tab-product m-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <DetailsTopTabs fetchingReviews={this.state.fetchingReviews} reviewsData={this.state.reviewsData}/>
                            </div>
                        </div>
                    </div>
                </section>

                {relatedProducts.lenght > 0 && <RelatedProduct products={relatedProducts} />}

                {/* <div className="yotpo yotpo-main-widget"
                    data-product-id={'SKU/'+product.variants[0].sku}
                    data-price={product.variants[0].priceV2.amount}
                    data-currency={product.variants[0].priceV2.currencyCode}
                    data-name={product.title}
                    // data-url="The urlof your product page"
                    // data-image-url="The product image url"
                    >
                </div>

                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                        (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/TmJl1EKB1v3qhdcx6WEO44JihQNKLoeyQFQ7X2Rk/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
                            `,
                    }}
                    /> */}
            </Layout>
        )
    }
}

export const query = graphql `
 query getRelatedProductsAndGetProduct ($handle: String!, $tags: [String]) {
    shopifyProduct(handle: { eq: $handle }) {
        id
        shopifyId
        title
        handle
        productType
        description
        descriptionHtml
        vendor
        options {
            id
            name
            values
        }
        variants {
            shopifyId
            title
            sku
            priceV2{
                amount
                currencyCode
            }
            compareAtPriceV2{
                amount
                currencyCode
            }
            availableForSale
            selectedOptions {
                name
                value
            }
        }
        priceRange {
            minVariantPrice {
                amount
                currencyCode
            }
            maxVariantPrice {
                amount
                currencyCode
            }
        }
        images {
            localFile {
                childImageSharp {
                    fluid(maxWidth: 800, maxHeight: 800) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
        smallImages: images {
            localFile {
                childImageSharp {
                    fixed(width: 150,height: 150) {
                        ...GatsbyImageSharpFixed_withWebp
                    }
                }
            }
        }
    }

    allShopifyProduct(filter: {tags: {in: $tags}}, limit: 8) {
        edges {
            node {
                shopifyId
                handle
                title
                description
                variants {
                    shopifyId
                    title
                    priceV2 {
                            amount
                            currencyCode
                        }
                    compareAtPriceV2 {
                            amount
                            currencyCode
                        }
                    selectedOptions {
                            name
                            value
                        }
                    image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 600, maxHeight: 600) {
                                    ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

// const mapStateToProps = (state, ownProps) => {
//     let productId = ownProps.match.params.id;
//     return {
//         item: state.data.products.find(el => el.id == productId),
//         symbol: state.data.symbol
//     }
// }

// export default connect(mapStateToProps, {addToCart, addToCartUnsafe, addToWishlist}) (LeftImage);

export default Product;